import { render, staticRenderFns } from "./AddWave.vue?vue&type=template&id=6a18788b&scoped=true&"
import script from "./AddWave.vue?vue&type=script&lang=ts&"
export * from "./AddWave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18788b",
  null
  
)

export default component.exports